export default {
    no_reservation_message:
        'Unfortunately, we couldn`t find any reservations matching your selected filters or you currently don`t have any active reservations.',
    no_timeline_reservation_message: 'Unfortunately, we did not find any reservations for the selected date.',
    reservation_number: '🚀 Number of reservations: {n}',
}
